import { CatContentCoverStyle } from "modules/app/styles"
import { ReactComponent as PictureIcon } from 'assets/images/icons/picture.svg'
import { ReactComponent as SmileIcon } from 'assets/images/icons/smile-emoji.svg'
import { ReactComponent as DropdownArrow } from 'assets/images/icons/dropdown-arrow.svg'
import { ReactComponent as DropdownArrowRight } from 'assets/images/icons/dropdown-arrow-right.svg'
import { ReactComponent as CancelIcon } from 'assets/images/icons/cancel-lg-icon.svg'
import { useEffect, useRef, useState } from "react"
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import CoverUploadModal from "./CoverIcon/CoverUploadModal"
import { connect } from "react-redux"
import { deleteIconAndCoverImage, repositionCoverImage, saveIconAndCoverImage } from "store/actions"
import { BsDash } from "react-icons/bs"
import { PageLoader } from "utils/storageUtils"
import { checkUser_for_admin_or_owner_or_editor } from "utils/helpers"

const CatContentCover = ({ row = null,
  resourceIcon = false,
  resourceCover = false,
  type,
  id,
  saveIconAndCoverImage,
  deleteIconAndCoverImage,
  repositionCoverImage,
  isRequestCallComplete,
  setLastFetchToken,
  isLoading,
  user,
  errorBag,
  isEditable = true,
  fullScreenStatus }) => {
  const [showIconDropwdown, setShowIconDropdown] = useState(false);
  const [showEmptyStateIconDropwdown, setShowEmptyStateIconDropdown] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [coverModal, setCoverModal] = useState(false);
  const [hoveringOnIcon, setHoveringOnIcon] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [isOSWindows, setIsOSWindows] = useState(false);
  const [resourceIconState, setResourceIconState] = useState(null);
  const [resourceCoverState, setResourceCoverState] = useState(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [resetPosition, setResetPosition] = useState({ left: 0, top: 0 });
  const [resourceProcessing, setResourceProcessing] = useState([]);

  const dropdownRef = useRef(null);
  const pickerRef = useRef(null);

  const containerRef = useRef(null);

  useEffect(() => {
    const desiredWidth = 500;
    const backgroundImage = new Image();
    backgroundImage.src = resourceCoverState;

    backgroundImage.onload = () => {
      const aspectRatio = backgroundImage.width / backgroundImage.height;


      const calculatedContainerHeight = desiredWidth / aspectRatio;

      setContainerHeight(calculatedContainerHeight);
    }

  }, [resourceCoverState, containerHeight, row]);

  let img = '';
  let y1 = ''
  let y2 = ''
  let x1 = ''
  let x2 = ''

  useEffect(() => {
    img = window.$('.filled-state__cover--img-container img');
    y1 = window.$('.filled-state__cover--img-container').height();
    y2 = img.height();
    x1 = window.$('.filled-state__cover--img-container').width();
    x2 = img.width();

  }, [resourceCoverState, isRequestCallComplete]);

  window.$(document).ready(function () {
    img = window.$('.filled-state__cover--img-container img');
    y1 = window.$('.filled-state__cover--img-container').height();
    y2 = img.height();
    x1 = window.$('.filled-state__cover--img-container').width();
    x2 = img.width();

  });

  const handleReposition = (event) => {
    event.preventDefault();
    img.draggable({
      disabled: false,
      scroll: false,
      axis: 'y, x',
      cursor: 'move',
      drag: function (event, ui) {
        if (ui.position.top >= 0) {
          ui.position.top = 0;
        }
        if (ui.position.top <= y1 - y2) {
          ui.position.top = y1 - y2;
        }
        if (ui.position.left >= 0) {
          ui.position.left = 0;
        };
        if (ui.position.left <= x1 - x2) {
          ui.position.left = x1 - x2;
        }

        setPosition(ui.position)
      }
    });
  };

  const onSelectEmoji = (emoji) => {
    handleSubmissionOfMedia(true, emoji?.native);

    setShowEmoji(false)
  }

  const hiddenIconFileInputRef = useRef(null);

  const handleSelectIconImage = () => {
    setShowEmoji(false)
    hiddenIconFileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    handleSubmissionOfMedia(true, selectedFile);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        !dropdownRef?.current?.contains(event.target) && !pickerRef?.current?.contains(event.target)
      ) {
        setShowIconDropdown(false);
        setShowEmptyStateIconDropdown(false);
        setShowEmoji(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (window.navigator.platform.indexOf("Win") !== -1) {
      setIsOSWindows(true)
    }
  }, [setIsOSWindows]);

  const handleSubmissionOfMedia = async (isIcon, media) => {
    if (isIcon) {
      setResourceProcessing(['icon'])
      setResourceIconState(null);
    } else {
      setResourceProcessing(['cover'])
      setResourceCoverState(null)
    }

    if (media?.toString()?.startsWith('preset')) {
      setResourceProcessing(['icon', 'cover'])
      setResourceIconState(null);
      setResourceCoverState(null)
    }

    let formData = new FormData();
    formData.append('model_type', type)
    formData.append('model_id', id)
    formData.append(isIcon ? 'icon' : 'cover', media)

    await saveIconAndCoverImage(formData);

    setCoverModal(false);
    setShowIconDropdown(false);
    setShowEmptyStateIconDropdown(false);
    setIsDragging(false)
  }

  const handleDeletionOfMedia = async (isIcon) => {
    if (isIcon) {
      setResourceProcessing(['icon'])
    } else {
      setResourceProcessing(['cover'])
    }
    
    await deleteIconAndCoverImage({
      model_type: type,
      model_id: id,
      is_icon: isIcon
    });

    setCoverModal(false);
    setShowIconDropdown(false);
    setShowEmptyStateIconDropdown(false);
  }

  const handleRepositionCoverImage = async () => {
    setResourceProcessing(['cover']);

    await repositionCoverImage({
      model_type: type,
      model_id: id,
      position: JSON.stringify(position)
    });

    setIsDragging(false)
  }

  useEffect(() => {
    if (row.cover_position?.length) {
      setPosition(JSON.parse(row.cover_position))
      setResetPosition(JSON.parse(row.cover_position))
    }

  }, [row.cover_position, setPosition, setResetPosition])

  useEffect(() => {
    if (isRequestCallComplete) {
      setResourceProcessing([])
      setLastFetchToken(new Date())
    }

  }, [isRequestCallComplete, setLastFetchToken]);

  useEffect(() => {
    setResourceIconState(resourceIcon)
  }, [resourceIcon]);

  useEffect(() => {
    setResourceCoverState(resourceCover)
  }, [resourceCover]);

  useEffect(() => {
    if (Object.keys(errorBag).length) {
      setResourceIconState(resourceIcon)
      setResourceCoverState(resourceCover)
    }
  }, [errorBag]);

  const handleChildHover = (e) => {
    if (Array.from(e.target.classList).some(className => className.startsWith('filled-state__icon'))) {
      setHoveringOnIcon(true)
    } else {
      setHoveringOnIcon(false)
    }
  }

  useEffect(() => {
    if (!resourceIcon) {
      setHoveringOnIcon(false)
    }
  }, [resourceIcon])

  return (
    <CatContentCoverStyle isfullscreen={fullScreenStatus} isDragging={isDragging} showEmoji={showEmoji} isOSWindows={isOSWindows} isViewer={checkUser_for_admin_or_owner_or_editor(row, user) && isEditable} coverPreset={resourceCover?.toString()?.startsWith('preset') ? resourceCover.split("-")[1] : null} unassignLeftSpace={type === 'category' && !resourceCover} showZeroState={showEmptyStateIconDropwdown}>
      <CoverUploadModal isFullScreen={fullScreenStatus} coverModal={coverModal} setCoverModal={setCoverModal} handleSubmissionOfMedia={handleSubmissionOfMedia} />
      <>
        <div className="zero-state">
          {(!resourceIcon && checkUser_for_admin_or_owner_or_editor(row, user) && isEditable) && (
            <>
              <div className="zero-state__add-icon" onClick={() => setShowEmptyStateIconDropdown(!showEmptyStateIconDropwdown)}>
                <SmileIcon />

                <p>Add Icon</p>
              </div>
              {showEmptyStateIconDropwdown && (
                <>
                  <div className="icon-dropdown" ref={dropdownRef}>
                    <span onMouseEnter={() => setShowEmoji(!showEmoji)}>Emoji <DropdownArrowRight /></span>
                    <span onClick={handleSelectIconImage}>Upload from file</span>
                  </div>
                  <input
                    type="file"
                    style={{ display: 'none' }}
                    ref={hiddenIconFileInputRef}
                    onChange={handleFileChange}
                    accept="image/png, image/gif, image/jpeg"
                  />
                  {showEmoji && (<div className={`emoji-picker`} ref={pickerRef}>
                    <Picker data={data} onEmojiSelect={onSelectEmoji} />
                  </div>)}
                </>)}
            </>)}
          {(!resourceCover && !hoveringOnIcon && checkUser_for_admin_or_owner_or_editor(row, user) && isEditable) && (
            <div className="zero-state__add-cover" onClick={() => setCoverModal(true)}>
              <PictureIcon />

              <p>Add Cover Image</p>
            </div>)}
        </div>


        {resourceIcon || resourceCover ? (
          <div className="filled-state" onMouseOver={handleChildHover}>
            {resourceProcessing?.includes('cover') && isLoading ? <PageLoader /> : (resourceCoverState?.length ? (
              <div className="filled-state__cover">
                {(checkUser_for_admin_or_owner_or_editor(row, user) && isEditable) && (
                  <>
                    <div className="filled-state__cover-control">
                      <div className="filled-state__cover-control--change-cover" onClick={() => setCoverModal(true)}>
                        <SmileIcon />

                        <p>Change cover</p>
                      </div>

                      <div className="filled-state__cover-control--remove-cover" onClick={() => handleDeletionOfMedia(false)}>
                        <BsDash />

                        <p>Remove</p>
                      </div>
                    </div>

                    {!resourceCoverState?.toString()?.startsWith('preset') && (<div className="filled-state__cover-repositioning">
                      {isDragging ? (
                        <>
                          <div className="filled-state__cover-repositioning--reset" onClick={() => setPosition(resetPosition)}>
                            <p>Reset</p>
                          </div>
                          <div className="filled-state__cover-repositioning--save" onClick={() => handleRepositionCoverImage()}>
                            <p>Save</p>
                          </div>
                        </>) :

                        <div className="filled-state__cover-repositioning--reposition" onClick={(event) => {
                          setIsDragging(true)
                          handleReposition(event)
                        }}>
                          <p>Reposition</p>
                        </div>}
                    </div>)}
                  </>
                )}
                {!resourceCoverState?.toString()?.startsWith('preset') && (
                  <div className="filled-state__cover--img-container" ref={containerRef}>
                    <img data-top={"0"} data-left="0" src={resourceCoverState} style={position} alt="Cover Image" />
                  </div>
                )}
                {/* d */}
              </div>) : null)}

            {resourceIconState?.length || (isLoading && resourceProcessing?.includes('icon')) ? (<>
              <div className="filled-state__icon">
                {(isLoading && resourceProcessing?.includes('icon')) ? <PageLoader /> : ((resourceIconState?.toString()?.startsWith('http') ||
                  resourceIconState?.toString()?.startsWith('www') ||
                  resourceIconState?.toString()?.startsWith('preset')) ?
                  (<img alt="img" src={resourceIconState?.toString()?.startsWith('preset') ?
                    require(`../../assets/images/preset/${resourceIconState.split("-")[1]}.png`) :
                    (resourceIconState?.length ? resourceIconState : '')} />) :
                  (<p>{resourceIconState?.length ? resourceIconState : ''}</p>))}
                {(checkUser_for_admin_or_owner_or_editor(row, user) && isEditable) && (<div className='filled-state__icon--button' onClick={() => setShowIconDropdown(!showIconDropwdown)}>Change <DropdownArrow className="filled-state__icon--button-dropdown" /></div>)}
              </div>
              {showIconDropwdown && (
                <>
                  <div className="icon-dropdown" ref={dropdownRef}>
                    <span onMouseEnter={() => setShowEmoji(!showEmoji)}>Emoji <DropdownArrowRight /></span>
                    <span onClick={handleSelectIconImage}>Upload from file</span>
                  </div>
                  <input
                    type="file"
                    style={{ display: 'none' }}
                    ref={hiddenIconFileInputRef}
                    onChange={handleFileChange}
                    accept="image/png, image/gif, image/jpeg"
                  />
                  {showEmoji && (<div className={`emoji-picker`} ref={pickerRef}>
                    <Picker data={data} onEmojiSelect={onSelectEmoji} />
                  </div>)}
                </>)}
              {(checkUser_for_admin_or_owner_or_editor(row, user) && isEditable) && (<div className='filled-state__icon-cancel' onClick={() => handleDeletionOfMedia(true)}> <CancelIcon /></div>)}
            </>) : null}
          </div>) : null}
      </>
    </CatContentCoverStyle>
  )
}

const mapStateToProps = state => ({
  isRequestCallComplete: state.contents?.isRequestCallComplete,
  errorBag: state.contents?.errorBag,
  isLoading: state.contents?.isLoading,
  user: state.auth.user,
  fullScreenStatus: state.contents.isFullScreen
})
const mapDispatchToProps = dispatch => {
  return {
    saveIconAndCoverImage: (data) => dispatch(saveIconAndCoverImage(data)),
    deleteIconAndCoverImage: (data) => dispatch(deleteIconAndCoverImage(data)),
    repositionCoverImage: (data) => dispatch(repositionCoverImage(data))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CatContentCover)